var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"department-overview"},[_c('div',{staticClass:"growth-overview-view"},[_c('title-bar',{staticClass:"title-bar-view",attrs:{"title":'科室总览',"showAll":false}}),_vm._v(" "),_c('GrowthOverview',{attrs:{"initData":_vm.journeyData}}),_vm._v(" "),_c('RadarChartAIFV',{attrs:{"initData":_vm.radarChartData,"totalData":_vm.totalData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a864a7a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xwzy/department.vue
// module id = null
// module chunks = 